import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { FormField } from 'site-modules/shared/components/form-field/form-field';
import {
  FIELD_DANGER_CLASS_NAMES,
  FORM_FIELD_CLASS_NAMES,
  FORM_FIELD_NAMES,
} from 'site-modules/shared/constants/write-review/write-review';

export function AuthorDetails({
  validate,
  fieldRef,
  validationErrors,
  onUserChange = null,
  profileData: { email, displayName, isAuthenticated },
  isUpdateForm = false,
}) {
  const { AUTHOR_NAME, EMAIL } = FORM_FIELD_NAMES;
  const isAutoLogin = !!(!isUpdateForm && email && isAuthenticated);

  return (
    <Fragment>
      <div className="heading-4 mb-0_5">{isUpdateForm ? 'Update your review' : 'Submit your review'}</div>
      {isAutoLogin ? (
        <Fragment>
          <div>Logged in as {email}</div>
          {!!onUserChange && (
            <Button
              color="link"
              className="p-0 size-12 mb-0_5 text-primary-darker text-transform-none"
              onClick={onUserChange}
              data-tracking-id="sign_out"
            >
              <span className="fw-normal">change</span>
            </Button>
          )}
        </Fragment>
      ) : (
        <div className="mb-1_25">
          {isUpdateForm
            ? 'Please verify the email used to create the original review.'
            : 'Please provide your email and author name to complete submission of your review.'}
        </div>
      )}

      {!isUpdateForm && (
        <Fragment>
          <FormField
            {...FORM_FIELD_CLASS_NAMES}
            ref={fieldRef}
            name={AUTHOR_NAME}
            id={AUTHOR_NAME}
            label={
              <Fragment>
                Author Name or Nickname*{' '}
                <span className="fw-normal">(will be published with your review, along with your city and state)</span>
              </Fragment>
            }
            placeholder="Enter your name as you'd like it to appear"
            maxLength={30}
            onBlur={validate}
            onChange={validate}
            isValid={!(AUTHOR_NAME in validationErrors)}
            inputClassName="py-0_5"
            defaultValue={isAuthenticated ? displayName : undefined}
          />
          <div className={FIELD_DANGER_CLASS_NAMES}>{validationErrors[AUTHOR_NAME]}</div>
        </Fragment>
      )}
      <FormField
        {...FORM_FIELD_CLASS_NAMES}
        ref={fieldRef}
        name={EMAIL}
        id={EMAIL}
        label={
          isUpdateForm ? (
            'Email*'
          ) : (
            <Fragment>
              Email*{' '}
              <span className="fw-normal">
                (will <i>not</i> be published with review)
              </span>
            </Fragment>
          )
        }
        placeholder="Enter your email address"
        type="email"
        autoComplete="email"
        onBlur={validate}
        onChange={validate}
        isValid={!(EMAIL in validationErrors)}
        inputClassName="py-0_5"
        defaultValue={isAuthenticated ? email : undefined}
        hidden={isAutoLogin}
      />
      <div className={FIELD_DANGER_CLASS_NAMES}>{validationErrors[EMAIL]}</div>
    </Fragment>
  );
}

AuthorDetails.propTypes = {
  fieldRef: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  validationErrors: PropTypes.shape({}).isRequired,
  profileData: PropTypes.shape({
    email: PropTypes.string,
    displayName: PropTypes.string,
    isAuthenticated: PropTypes.bool,
  }).isRequired,
  onUserChange: PropTypes.func,
  isUpdateForm: PropTypes.bool,
};
